type StoreActivation = Record<
	string,
	{
		country: string;
		storeid: string;
		customerlogin: string;
		submitbackend: string;
		onlinevisibility: "DISABLED" | "ACTIVE";
	}
>;
const CountryUtil = {
	getCountry(): string {
		return window.country || "DE";
	},

	isAllowingMultiOQ(): boolean {
		return (window.countriesAllowingMultiOQ || "").split(",").includes(CountryUtil.getCountry());
	},

	isMcrmCountry(): boolean {
		const storeactivation: StoreActivation = window.storeactivation ?? {};
		const activeStores = Object.values(storeactivation).filter(store => store.customerlogin === "ACTIVE");
		// In case we have no active stores, we assume that we want M:FULFILL - which also
		// happens to be the expected behaviour locally.
		return activeStores.length > 0 && activeStores.every(store => store.submitbackend === "MCRM");
	},

	/**
	 * Deprecated alias for isOnlineVisible.
	 */
	isMarioCountry(): boolean {
		return CountryUtil.isOnlineVisible();
	},

	returnsAlexCustomersInOldCustomerdata(): boolean {
		return window.returns_alex_customers_in_old_customerdata;
	},

	isCustomersFromNonMCRMSources(): boolean {
		return window.is_customers_from_non_mcrm_sources;
	},

	isOnlineVisible(): boolean {
		// TODO(FD) rename the env var as well, or rather move it to the country configmap
		const ovCountries = (window.mario_countries || "FR").split(",");
		return ovCountries.includes(CountryUtil.getCountry());
	},

	isEnzoCountry(): boolean {
		const enzoCountries = (window.enzo_countries || "").split(",");
		return enzoCountries.includes(CountryUtil.getCountry());
	},

	getOnlineVisibleStores(): string[] {
		const storeactivation: StoreActivation = window.storeactivation;
		return (Object.values(storeactivation) as any)
			.filter(s => s.onlinevisibility === "ACTIVE" && s.country === CountryUtil.getCountry())
			.map(s => s.storeid);
	},

	isCombiOrderCountry(): boolean {
		const combiOrderCountries = (window.combi_order_countries || "FR").split(",");
		return combiOrderCountries.includes(CountryUtil.getCountry());
	},

	loyaltyPointsActive(): boolean {
		return window.loyaltyPointsActive || false;
	},

	businessAccountsActive(): boolean {
		return window.businessAccountsActive || false;
	},

	displayAnonLandingPage(): boolean {
		return window.displayAnonLandingPage || false;
	},

	getSalesLine(): string {
		return window.salesline || "metro";
	},

	getOptionalConfig(): Record<string, any> {
		return window.optionalCountryConfig || {};
	},

	getOcCountryConfig(): Record<string, any> {
		return window.ocCountryConfig || {};
	},

	getPerDomainConfig(): Record<string, any> {
		const config = CountryUtil.getOptionalConfig();
		const domain = window.location.hostname.toLowerCase();
		return (config.domainSettings && config.domainSettings[domain]) || {};
	},

	getCountryConfig(): Record<string, any> {
		return window.countryConfig || {};
	},

	getFlyoutConfig(): Record<string, any> {
		return window.flyoutConfig || {};
	},
};
export default CountryUtil;
